var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSupported)?_c('div',{staticClass:"vue-audio-recorder",class:{
    'active': _vm.isRecording,
    'paused': _vm.isPaused
  },on:{"mousedown":_vm.startRecording,"mouseleave":_vm.stopRecording,"mouseup":_vm.stopRecording,"touchstart":_vm.startRecording,"touchend":_vm.stopRecording,"touchcancel":_vm.stopRecording}},[_c('span')]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }